import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import Recaptcha from 'react-google-recaptcha';
import './styles.scss';
import services from '../../services';

import logoCompany from '../../assets/img/companyLogo.png';
import logoTopoCompany from '../../assets/img/companyLogoTopo.png';
import { useDispatch } from 'react-redux';
import {
  showMsgW as showMsgWAction,
  showMsgE as showMsgEAction,
  //showMsgS as showMsgSAction,
} from '../../store/actions/snackbarActions.js';
import globals from '../../globals';
import { validaCpf } from '../../services/validaCpf.js';
import { validaSenha } from '../../services/validaSenha.js';
import DOMPurify from 'dompurify';

const sanitizeInput = (inputData) => {
  return DOMPurify.sanitize(inputData);
};

const RECAPTCHA_KEY = globals.REACT_APP_RECAPTCHA_KEY;
const formLoginInitialState = { login: '', senha: '' };

const FormLogin = ({ modalSenha, modalPrimeiroAcesso }) => {
  const history = useHistory();
  const recaptcha = useRef(null);
  const dispatch = useDispatch();
  const showMsgW = (msg) => dispatch(showMsgWAction(msg));
  const showMsgE = (msg) => dispatch(showMsgEAction(msg));
  //const showMsgS = (msg) => dispatch(showMsgSAction(msg));

  const [formLogin, setFormLogin] = useState({ ...formLoginInitialState });
  const [indicarErrosLogin, setIndicarErrosLogin] = useState(false);

  const logar = () => {
    if (!formLogin.login || !formLogin.senha) {
      setIndicarErrosLogin(true);
      showMsgW('Informe os campos obrigatórios');
      return false;
    }
    if (!services.validate.valideCpf(services.mask.unMask(formLogin.login))) {
      showMsgW('Informe um cpf válido');
      return false;
    }

    logarAuto();
  };

  const logarAuto = () => {
    if (recaptcha.current) {
      trackPromise(
        recaptcha.current
          .executeAsync()
          .then((recaptchaToken) => {
            services.storage.set('captcha', recaptchaToken);
       
            services.apiAuto
              .logar({
                userName: services.mask.unMask(formLogin.login),
                password: formLogin.senha,
              })
              .then((res) => {
                if (res.fail) {
                  showMsgE('Você não tem permissão para acessar o sistema');
                  return;
                }

                if (res.data.profile.role.displayName !== 'Administrador') {
                  services.storage.set('authSistema', res.data);
                  services.storage.set('isAuthenticated', true);
                  services.storage.set(
                    'timeLimit',
                    new Date(new Date().getTime() + 1000 * 60 * 15)
                  );
                  if (res.data?.profile?.role?.displayName === 'Recrutador') {
                    services.storage.set('isUserCompany', true);
                    if (res.data.profile.cadastroCompleto) {
                      history.push('/home');
                      return false;
                    } else {
                      history.push(`/meu-cadastro`);
                    }
                  } else {
                    services.storage.set('isUserCompany', false);
                    if (res.data.profile.cadastroCompleto) {
                      history.push('/home');
                      return false;
                    } else {
                      history.push(`/meu-cadastro`);
                    }
                  }
                } else {
                  showMsgE(res.errors ? res.errors.message : 'Erro');
                }
              });
          })
          .catch((error) => {
            //showMsgE(error.errors.length ? error.errors[0].message : 'Error')
          })
      );
    }
  };

  const cpfMask = (value) => {
    return value
      .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
      .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
  };
  const handleInputChange = (event, campo) => {
    const sanitizedValue = sanitizeInput(event);
    setFormLogin((prevstate) => ({ ...prevstate, [campo]: sanitizedValue }));
  };

  if (formLogin.login != null) {
    formLogin.login = cpfMask(formLogin.login);
  }

  useEffect(() => {
    async function init() {}
    init();
  }, []);

  return (
    <div className="limitContainer">
      <div className="row">
        <div className="col-sm-12">
          <div className="containerLogoTopoImage">
            <img src={logoTopoCompany} alt=" " />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 padB120">
          <div className="containerLogoImage">
            <img src={logoCompany} alt=" " />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 padB20">
          <div className="input-container">
            <form autoComplete="off">
              <input
                id="cpf"
                className="input inputForm form-control form-control-lg"
                onChange={(event) =>
                  handleInputChange(event.target.value, 'login')
                }
                value={formLogin.login}
                type="text"
                pattern=".+"
                required
                name="username"
              />
              <label className="label" htmlFor="cpf">
                CPF
              </label>
              <div className="avisoCampo">
                {validaCpf(formLogin.login) || formLogin.login.length < 14
                  ? ' '
                  : 'Inserir CPF valido'}
              </div>
            </form>
          </div>
        </div>
        <div className="col-sm-12 padB20">
          <div className="input-container">
            <form autoComplete="off">
              <input
                id="senha"
                value={formLogin.senha}
                className="input inputForm form-control form-control-lg"
                onChange={(event) =>
                  handleInputChange(event.target.value, 'senha')
                }
                maxLength="20"
                type="password"
                required
              />
              <label className="label" htmlFor="senha">
                Senha
              </label>
              <div className="avisoCampo">
                {validaSenha(formLogin.senha) || formLogin.senha.length < 1
                  ? ' '
                  : 'Inserir senha valida'}
              </div>
            </form>
          </div>
        </div>
        <div className="col-sm-12 alignSenha">
          <button className="btn btn-link textSenha" onClick={modalSenha}>
            Esqueci minha senha
          </button>
        </div>
        <div className="col-sm-12 padB20">
          <Recaptcha ref={recaptcha} sitekey={RECAPTCHA_KEY} size="invisible" />
          <button
            className="btnEntrar"
            onClick={logar}
            disabled={
              !validaCpf(formLogin.login) || !validaSenha(formLogin.senha)
            }
          >
            Entrar
          </button>
        </div>
        {/* <div className="col-sm-12">
          <button
            className="btn btnPrimeiraVez btn-block btn-lg"
            onClick={modalPrimeiroAcesso}
          >
            Primeira vez aqui? <b className="textCadastrese">Cadastre-se.</b>
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default FormLogin;
